export const applyStylesToTags = (content) => {
    const tagsToReplace = ['p', 'ol', 'ul', 'pre', 'blockquote', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'];

    return tagsToReplace.reduce((modified, tag) => {
        const regex = new RegExp(`<${tag}([^>]*)>`, 'g');
        const replacement = `<${tag} style="margin: 0; padding: 0;"$1>`;
        return modified.replaceAll(regex, replacement);
    }, content);
};